export enum GeneratorAgeType {
    All = 1,
    '0-30',
    '31-60',
    '61+',
}

export const GeneratorAgeTypes = [
    {
        labelKey: 'common.generatorAgeTypes.all',
        value: GeneratorAgeType.All,
    },
    {
        labelKey: 'common.generatorAgeTypes.0-30',
        value: GeneratorAgeType['0-30'],
    },
    {
        labelKey: 'common.generatorAgeTypes.31-60',
        value: GeneratorAgeType['31-60'],
    },
    {
        labelKey: 'common.generatorAgeTypes.61+',
        value: GeneratorAgeType['61+'],
    },
] as const
